import { fork } from "redux-saga/effects";

import watchAuthSaga from "../modules/login/services/LoginSaga";
import adminSaga from "../modules/admin/services/adminSaga";
import commonSaga from "../modules/common/services/commonSaga";
import dropdownManagementSaga from "../modules/admin/dropdownManagement/services/dropdownMgmtSaga";
import configurationSaga from "../modules/admin/configuration/services/configurationSaga";
import radSaga from "../modules/rad/services/radSaga";
import examSaga from "../modules/exam/services/examSaga";
import siteSaga from "../modules/site/services/siteSaga";
// import unassignedSiteListSaga from "../modules/site/unassignedSiteList/services/unassignedSiteListSaga"; 
import reportSaga from "../modules/reports/services/reportSaga";
import dailyReportSaga from "../modules/reports/dailyReport/services/dailyReportSaga";
import marketVolumeShareSaga from "../modules/reports/marketVolumeShare/services/marketVolumeShareSaga";
import coverageGapToolEncoreSaga from "../modules/reports/coverageGapToolEncore/services/coverageGapToolEncoreSaga";
import performanceDashboardCombinedSaga from "../modules/reports/performanceDashboardCombined/services/performanceDashboardCombinedSaga";
import editSiteProfileSaga from "../modules/site/editSiteProfile/services/editSiteProfileSaga";
import strategicforcecastSaga from "../modules/StrategicForecast/services/strategicforcecastSaga";
import watchDemandTableSaga from '../modules/demandTable/services/DemandTableSaga';
import watchStrategicDemandPlanner from "../modules/StrategicForecast/strategicdemandplanner/services/strategicdemandsaga";
import watchVolumneTrendReportSaga from '../modules/volumeTrendReport/services/VolumeTrendSaga';
import watchStrategicCapacity from "../modules/StrategicForecast/strategiccapacityplanner/services/strategiccapacitysaga";
import watchCapacityTableSaga from '../modules/capacityTable/services/CapacityTableSaga';
import watchCapsvsDemandSaga from '../modules/capacityVsdemnadTable/services/CapacityvsDemandTableSaga';
import strategicCapsVsDemandSaga from '../modules/StrategicForecast/strategicCapsVsDemPlanner/services/strategicCapsVsDemandSaga';
import watchTenantManagementSaga from '../modules/tenantManagement/services/TenantManagementSaga';
import watchTenantHierarchyConfigurationSaga from '../modules/tenantHierarchyConfiguration/services/TenantHierarchyConfigurationSaga';
import watchTimeZoneMasterSaga from '../modules/timeZoneMaster/services/TimeZoneMasterSaga';
import watchLiveAvailableShiftsSaga from '../modules/liveAvailableShifts/services/LiveAvailableShiftsSaga';
import watchForecastSaga from '../modules/demandForecast/forecasting/services/forecastSaga';
import watchForecastSaga2 from '../modules/demandForecast2/forecasting/services/forecastSaga';
import watchforecastingForecastSaga from '../modules/forecasting/forecast/services/ForecastingForecastSaga';
import scheduleViewerSaga from '../modules/schedule/services/scheduleViewerSaga';
import shareLinksWatcher from '../modules/schedule/shareLinks/services/ShareLinksSaga';
import schedulingCalendarSaga from '../modules/schedulingCalendar/services/schedulingCalendarSaga';
import providerRequestSaga from '../modules/schedule/providerRequest/services/providerRequestSaga';
import licensePrivilegesPowerSyncSaga from '../modules/rad/licensePrivilegesPowerSync/services/licensePrivilegesPowerSyncSaga';
import watchChangePasswordSaga from '../modules/changePassword/services/changePasswordSaga';

function* rootSaga() {
    yield fork(watchAuthSaga);
    yield fork(adminSaga);
    yield fork(commonSaga);
    yield fork(dropdownManagementSaga);
    yield fork(configurationSaga);
    yield fork(radSaga);
    yield fork(examSaga);
    yield fork(siteSaga);
    // yield fork(unassignedSiteListSaga); 
    yield fork(reportSaga);
    yield fork(dailyReportSaga);
    yield fork(marketVolumeShareSaga);
    yield fork(coverageGapToolEncoreSaga);
    yield fork(performanceDashboardCombinedSaga);
    yield fork(editSiteProfileSaga);
    yield fork(strategicforcecastSaga);
    yield fork(watchDemandTableSaga);
    yield fork(watchStrategicDemandPlanner);
    yield fork(watchVolumneTrendReportSaga);
    yield fork(watchStrategicCapacity);
    yield fork(watchCapacityTableSaga);
    yield fork(watchCapsvsDemandSaga);
    yield fork(strategicCapsVsDemandSaga);
    yield fork(watchTenantManagementSaga);
    yield fork(watchTenantHierarchyConfigurationSaga);
    yield fork(watchTimeZoneMasterSaga);
    yield fork(watchLiveAvailableShiftsSaga);
    yield fork(watchForecastSaga);
    yield fork(watchForecastSaga2);
    // yield fork(watchforecastingForecastSaga);
    yield fork(scheduleViewerSaga);
    yield fork(shareLinksWatcher);
    yield fork(schedulingCalendarSaga);
    yield fork(providerRequestSaga);
    yield fork(licensePrivilegesPowerSyncSaga);
    yield fork(watchChangePasswordSaga);
}

export default rootSaga;